(function ($) {
    var migrosLoginEndpoint = CONFIG.mLoginEndpoint;
    updateLoginButtonUi();

    function updateLoginButtonUi() {
        var language = $('html').attr('lang');
        var loginButton = $('.mlogin__button');

        if (mLoginData.loggedInUser) { // if user is logged in
            var returnUri = encodeURIComponent(decodeURI(window.location.href)); //encodeURIComponent encodes also ampersands and query string elements : https://stackoverflow.com/questions/11294107/how-can-i-send-the-ampersand-character-via-ajax
            $('.mlogin__user')
                .show()
                .attr('href', `${migrosLoginEndpoint}/inlink/migrol/${language}/welcome?return_to=${returnUri}`)
                .html(mLoginData.loggedInUser.firstName + " " + mLoginData.loggedInUser.lastName)
                .show();

            loginButton.text(CONFIG.mLoginTextLogout);
            loginButton.attr('href', window.mLoginData.logoutUrl);
        }
        else { // if user not logged in
            $('.mlogin__user').hide();
            loginButton.text(CONFIG.mLoginTextLogin);
            loginButton.attr('href', window.mLoginData.loginUrl);
        }
    }
})(jQuery);


